import { authApiService } from '@/api/authApiService';
import { ApiParams } from '@/api/helpers/apiHelpers';
import { ApiResponseType, ListResponseType } from '@/types/sharedTypes';
import { TaskType } from '@/types/dashboardTypes';

export const getTasksApi = (params?: ApiParams): Promise<ApiResponseType<ListResponseType<TaskType>>> => {
  return authApiService.GET('/dashboard/tasks/', params);
};
